import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

interface TeleopSectionProps {
  value: any;
  onChange: (value: any) => void;
}

export const TeleopSection: React.FC<TeleopSectionProps> = ({ value, onChange }) => {
  const [expanded, setExpanded] = useState(true);

  const increment = (field: string) => {
    onChange({ ...value, [field]: (value[field] || 0) + 1 });
  };

  const decrement = (field: string) => {
    onChange({ ...value, [field]: Math.max(0, (value[field] || 0) - 1) });
  };

  return (
    <motion.div className="glass p-6 mb-4" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 20 }}>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between mb-4"
      >
        <h2 className="subsection-title mb-0">Teleop Period</h2>
        <ChevronDown className={`w-5 h-5 transition-transform ${expanded ? 'rotate-180' : ''}`} />
      </button>

      {expanded && (
        <>
          <div className="mb-4">
            <label className="form-label">Teleop Fuel Scored</label>
            <div className="flex items-center gap-4">
              <motion.button
                type="button"
                onClick={() => decrement('teleop_fuel_scored')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-secondary btn-touch text-xl"
              >
                −
              </motion.button>
              <span className="text-2xl font-bold text-center flex-1">{value.teleop_fuel_scored}</span>
              <motion.button
                type="button"
                onClick={() => increment('teleop_fuel_scored')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-primary btn-touch text-xl"
              >
                +
              </motion.button>
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label">Average Cycle Time (seconds)</label>
            <input
              type="number"
              step="0.5"
              value={value.average_cycle_time}
              onChange={(e) => onChange({ ...value, average_cycle_time: parseFloat(e.target.value) || 0 })}
              className="form-input"
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Tower Level</label>
            <select value={value.teleop_tower_level} onChange={(e) => onChange({ ...value, teleop_tower_level: e.target.value })} className="form-input">
              <option value="None">None</option>
              <option value="Level 1">Level 1 (10 pts)</option>
              <option value="Level 2">Level 2 (20 pts)</option>
              <option value="Level 3">Level 3 (30 pts)</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="form-label">Defense Played Level</label>
            <select value={value.defense_played_level} onChange={(e) => onChange({ ...value, defense_played_level: e.target.value })} className="form-input">
              <option value="None">None</option>
              <option value="Light">Light</option>
              <option value="Heavy">Heavy</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="form-label">Was Defended Level</label>
            <select value={value.was_defended_level} onChange={(e) => onChange({ ...value, was_defended_level: e.target.value })} className="form-input">
              <option value="None">None</option>
              <option value="Light">Light</option>
              <option value="Heavy">Heavy</option>
            </select>
          </div>

          <div>
            <label className="form-label">Missed Attempts</label>
            <div className="flex items-center gap-4">
              <motion.button
                type="button"
                onClick={() => decrement('teleop_missed_attempts')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-secondary btn-touch text-xl"
              >
                −
              </motion.button>
              <span className="text-2xl font-bold text-center flex-1">{value.teleop_missed_attempts}</span>
              <motion.button
                type="button"
                onClick={() => increment('teleop_missed_attempts')}
                whileTap={{ scale: 0.95 }}
                className="btn btn-primary btn-touch text-xl"
              >
                +
              </motion.button>
            </div>
          </div>
        </>
      )}
    </motion.div>
  );
};
